const local_API = "https://scramble-admin.rage.fan:8081/api/";
// const local_API = "http://localhost:8081/api/";
// const server_API = "http://ftbapp.smartchain.in:3000/api/";
/** If enviroinment is production it take @param server_API else it will take @param local_API*/
// const API_URL = process.env.NODE_ENV == "production" ? server_API : local_API;
// const API_URL = "http://localhost:8081/api/";
const API_URL = "https://scramble-admin.rage.fan:8081/api/";
const ImageUrl = "http://localhost:8081/static/doc/";

import { API_ENDPOINT } from "./utils/constants.js";
import { authHeader } from "./_helpers";
import axios from "axios";

export const APIService = {
  ImageUrl,
  signUp(data) {
    const url = `${API_URL}${API_ENDPOINT.SIGN_UP}`;
    return axios.post(url, data).then(res => res.data)
  },
  login(data) {
    const url = `${API_URL}${API_ENDPOINT.LOGIN}`;
    return axios.post(url, data).then(res => res.data);
  },
  // getAllCountry() {
  //   const url = `${API_URL}${API_ENDPOINT.COUNTRY}`;
  //   const header = {
  //     headers: authHeader()
  //   };
  //   return axios.get(url, header).then(res => res.data);
  // },
  saveToken(data) {
    localStorage.setItem("user", JSON.stringify(data.data));
    localStorage.setItem("token", data.token);
  },
  getUserInfo() {
    const url = `${API_URL}${API_ENDPOINT.USER_INFO}`;
    const header = {
      "headers": authHeader()
    };
    return axios.get(url, header).then(res => res.data)
  },
  saveSpecies(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_SPECIES}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  speciesList() {
    const url = `${API_URL}${API_ENDPOINT.SPECIES_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  speciesUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.SPECIES_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  speciesDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.SPECIES_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  // Breed
  saveBreed(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_BREED}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  breedList() {
    const url = `${API_URL}${API_ENDPOINT.BREED_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  breedUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.BREED_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  breedDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.BREED_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  // CHILLING 


  saveChilling(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_CHILLING}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  chillingList() {
    const url = `${API_URL}${API_ENDPOINT.CHILLING_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  chillingUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.CHILLING_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  chillingDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.CHILLING_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveZone(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_ZONE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  zoneList() {
    const url = `${API_URL}${API_ENDPOINT.ZONE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  zoneUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.ZONE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  zoneDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.ZONE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveRoute(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_ROUTE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  routeList() {
    const url = `${API_URL}${API_ENDPOINT.ROUTE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  routeUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.ROUTE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  routeDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.ROUTE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveSociety(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_SOCIETY}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  societyList() {
    const url = `${API_URL}${API_ENDPOINT.SOCIETY_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  societyUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.SOCIETY_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  societyDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.SOCIETY_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveFarmer(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_FARMER}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  farmerList() {
    const url = `${API_URL}${API_ENDPOINT.FARMER_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  farmerUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.FARMER_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  farmerDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.FARMER_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveSire(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_SIRE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  sireList() {
    const url = `${API_URL}${API_ENDPOINT.SIRE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  sireUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.SIRE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  sireDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.SIRE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveStaff(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_STAFF}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  staffList() {
    const url = `${API_URL}${API_ENDPOINT.STAFF_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  staffUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.STAFF_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  staffDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.STAFF_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },



  saveUnion(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_UNION}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  unionList() {
    const url = `${API_URL}${API_ENDPOINT.UNION_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  unionUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.UNION_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  unionDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.UNION_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveDistricts(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_DISTRICTS}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  districtsList() {
    const url = `${API_URL}${API_ENDPOINT.DISTRICTS_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  districtsUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.DISTRICTS_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  districtsDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.DISTRICTS_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveTasks(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_TASKS}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  tasksList() {
    const url = `${API_URL}${API_ENDPOINT.TASKS_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  tasksUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.TASKS_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  tasksDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.TASKS_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveUser(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_USER}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveAnimal(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_ANIMAL}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  animalList() {
    const url = `${API_URL}${API_ENDPOINT.ANIMAL_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  animalUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.ANIMAL_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  animalDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.ANIMAL_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveContainermaster(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_CONTAINERMASTER}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  containermasterList() {
    const url = `${API_URL}${API_ENDPOINT.CONTAINERMASTER_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  containermasterUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.CONTAINERMASTER_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  containermasterDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.CONTAINERMASTER_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveMedicinetype(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_MEDICINETYPE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  medicinetypeList() {
    const url = `${API_URL}${API_ENDPOINT.MEDICINETYPE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  medicinetypeUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.MEDICINETYPE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  medicinetypeDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.MEDICINETYPE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveNutrientType(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_NUTRIENTTYPE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  nutrienttypeList() {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENTTYPE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  nutrienttypeUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENTTYPE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  nutrienttypeDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENTTYPE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },


  saveNutrient(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_NUTRIENT}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  nutrientList() {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENT_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  nutrientUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENT_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  nutrientDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.NUTRIENT_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveFeedgroup(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_FEEDGROUP}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  feedgroupList() {
    const url = `${API_URL}${API_ENDPOINT.FEEDGROUP_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  feedgroupUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.FEEDGROUP_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  feedgroupDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.FEEDGROUP_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveIngradiant(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_INGRADIANT}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  ingradiantList() {
    const url = `${API_URL}${API_ENDPOINT.INGRADIANT_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  ingradiantUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.INGRADIANT_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  ingradiantDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.INGRADIANT_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  savetaskBreed(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_TASK_BREED}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveBodyWeight(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_BODYWEIGHT}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightList() {
    const url = `${API_URL}${API_ENDPOINT.BODYWEIGHT_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  bodyWeightUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.BODYWEIGHT_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.BODYWEIGHT_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  saveMilk(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_Milk}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  milkList() {
    const url = `${API_URL}${API_ENDPOINT.Milk_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  milkUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.Milk_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  milkDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.Milk_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  savePregnancy(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_PREGNANCY}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  pregnancyList() {
    const url = `${API_URL}${API_ENDPOINT.PREGNANCY_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  pregnancyUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.PREGNANCY_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  pregnancyDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.PREGNANCY_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveDurgMaster(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_DRUG_MASTER}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  durgMasterList() {
    const url = `${API_URL}${API_ENDPOINT.DRUG_MASTER_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  durgMasterUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.DRUG_MASTER_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  durgMasterDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.DRUG_MASTER_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveBodyWeightLot(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_BODY_WEIGHT_LOT}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightLotList() {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_LOT_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  bodyWeightLotUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_LOT_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightLotDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_LOT_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveBodyWeightIndividual(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_BODY_WEIGHT_INDIVIDUAL}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightIndividualList() {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_INDIVIDUAL_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  bodyWeightIndividualUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_INDIVIDUAL_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyWeightIndividualDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_WEIGHT_INDIVIDUAL_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveBodyScore(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_BODY_SCORE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyScoreList() {
    const url = `${API_URL}${API_ENDPOINT.BODY_SCORE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  bodyScoreUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_SCORE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  bodyScoreDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.BODY_SCORE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  saveServices(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_SERVICE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  serviceList() {
    const url = `${API_URL}${API_ENDPOINT.SERVICE_LIST}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.get(url).then(res => res.data)
  },
  servicesUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.SERVICE_UPDATE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },
  serviceDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.SERVICE_DELETE}`;
    // const header = {
    //   "headers": authHeader()
    // };
    return axios.post(url, data).then(res => res.data)
  },

  // getallcountry() {
  //   const url = `${API_URL}${API_ENDPOINT.GET_ALL_COUNTRY}`;
  //   // const header = {
  //   //   "headers": authHeader()
  //   // };
  //   return axios.get(url).then(res => res.data)
  // },
  // getState(data) {
  //   const url = `${API_URL}${API_ENDPOINT.GET_STATE}`;
  //   // const header = {
  //   //   "headers": authHeader()
  //   // };
  //   return axios.post(url, data).then(res => res.data)
  // },
  // getcity(data) {
  //   const url = `${API_URL}${API_ENDPOINT.GET_CITY}`;
  //   // const header = {
  //   //   "headers": authHeader()
  //   // };
  //   return axios.post(url, data).then(res => res.data)
  // },
  saveFarmUser(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_FARM_USER}`;
    return axios.post(url, data).then(res => res.data)
  },

  getFarmUser() {
    const url = `${API_URL}${API_ENDPOINT.GET_FARM_USER}`;
    return axios.get(url).then(res => res.data)
  },
  getUserList(data) {
    const url = `${API_URL}${API_ENDPOINT.GET_USER_LIST}`;

    return axios.post(url, data).then(res => res.data)
  },
  deleteUser(data) {
    const url = `${API_URL}${API_ENDPOINT.USER_DELETE}`;

    return axios.post(url, data).then(res => res.data)
  },

  userUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.USER_UPDATE}`;

    return axios.post(url, data).then(res => res.data)
  },
  userResetPassword(data) {
    const url = `${API_URL}${API_ENDPOINT.USER_RESET_PASSWORD}`;

    return axios.post(url, data).then(res => res.data)
  },
  getUserDetails(data) {
    const url = `${API_URL}${API_ENDPOINT.USER_INFO}`;

    return axios.post(url, data).then(res => res.data)
  },



  getAllCountry() {

    const url = `${API_URL}${API_ENDPOINT.GET_ALL_COUNTRY}`;
    const header = {
      headers: authHeader()
    };
    return axios.get(url, header).then(res => res.data);
  },
  // async getState(data) {
  //   const url = `${API_URL}${API_ENDPOINT.GET_STATE}`;
  //   const header = {
  //     headers: authHeader()
  //   };
  //   const res = await axios.post(url, data, header);
  //   return res.data;
  // },
  // async getCity(data) {
  //   const url = `${API_URL}${API_ENDPOINT.GET_CITY}`;
  //   const header = {
  //     headers: authHeader()
  //   };
  //   const res = await axios.post(url, data, header);
  //   return res.data;
  // },
  getState(data) {
    const url = `${API_URL}${API_ENDPOINT.GET_STATE}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  getCity(data) {
    const url = `${API_URL}${API_ENDPOINT.GET_CITY}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  saveRageToken(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_TOKEN}`;
    const header = {
      "headers": authHeader()
    };
    return axios.post(url, data, header).then(res => res.data)
  },
  gettokens() {
    const url = `${API_URL}${API_ENDPOINT.GET_TOKEN}`;
    const header = {
      "headers": authHeader()
    };
    return axios.get(url, header).then(res => res.data)
  },
  tokenlogo(data) {
    const url = `${API_URL}${API_ENDPOINT.TOKEN_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  updateTokenlogo(data) {
    const url = `${API_URL}${API_ENDPOINT.UPDATE_TOKEN_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  uploadvideo(data) {
    const url = `${API_URL}${API_ENDPOINT.UPLOAD_VIDEO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  reUploadvideo(data) {
    const url = `${API_URL}${API_ENDPOINT.REUPLOAED_VIDEO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },

  tokenDisplayLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.TOKEN_DISPLAY_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },

  retokenDisplayLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.RE_TOKEN_DISPLAY_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },

  tokenCaptureLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.TOKEN_CAPTURE_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },

  retokenCaptureLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.RE_TOKEN_CAPTURE_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },

  tokenthreeLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.TOKEN_THREE_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  retokenthreeLogo(data) {
    const url = `${API_URL}${API_ENDPOINT.RE_TOKEN_THREE_LOGO}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  saveproducts(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_PRODUCTS}`;
    const header = {
      "headers": authHeader()
    };
    return axios.post(url, data, header).then(res => res.data)
  },

  productimages(data) {
    const url = `${API_URL}${API_ENDPOINT.PRODUCT_IMAGES}`;
    const header = {
      headers: authHeader()
    };
    return axios.post(url, data, header).then(res => res.data);
  },
  getproducts() {
    const url = `${API_URL}${API_ENDPOINT.GET_PRODUCTS}`;
    const header = {
      "headers": authHeader()
    };
    return axios.get(url, header).then(res => res.data)
  },








  sendAlluser(data) {
    const url = `${API_URL}${API_ENDPOINT.SEND_ALLUSER}`;

    return axios.post(url, data).then(res => res.data)
  },

  sendParticularuser(data) {
    const url = `${API_URL}${API_ENDPOINT.SEND_PARTICULAR}`;

    return axios.post(url, data).then(res => res.data)
  },



  savetestdata(data) {
    const url = `${API_URL}${API_ENDPOINT.SAVE_TESTDATA}`;

    return axios.post(url, data).then(res => res.data)
  },

  gettestdata() {
    const url = `${API_URL}${API_ENDPOINT.GET_TESTDATA}`;

    return axios.get(url).then(res => res.data)
  },

  testdataUpdate(data) {
    const url = `${API_URL}${API_ENDPOINT.UPDATE_TESTDATA}`;

    return axios.post(url, data).then(res => res.data)
  },
  testdataDelete(data) {
    const url = `${API_URL}${API_ENDPOINT.DELETE_TESTDATA}`;
    return axios.post(url, data).then(res => res.data)
  },
  getpromocode() {
    const url = `${API_URL}${API_ENDPOINT.GET_PROMOCODEUSER}`;

    return axios.get(url).then(res => res.data)
  },

  esportsGameUpdate(data) {
    const url = `https://scramble-api.rage.fan/saveESportsGame`;
    return axios.post(url, data).then(res => res.data)
  },

  isTournamentEdit(docId) {
    const url = `https://scramble-api.rage.fan/isTournamentEdit`;

    return axios({
      url: url,
      params: {
        docId
      },
      method: "get",
    }).then(res => res.data)
  },

}